import "./assets/bootstrap.min.css";
import "./assets/all.min.css";
import "./App.css";
import "./fonts.css";
import { HashRouter, Navigate, Route, Routes } from "react-router-dom";
import Athletelogin from "./components/athletelogin";
import MoreInfo from "./components/more";
import Logout from "./components/logout";
import AddHomework from "./components/addhomework";
import TrackingDashboard from "./components/tracking-dashboard";
import TimeTable from "./components/timetable";
import Homework from "./components/homework";
import TrackingNotification from "./components/tracking-notification";
import AddAttendance from "./components/addattendance";
import MyAttendance from "./components/myattendance";
import MyProfile from "./components/profile";
import About from "./components/about";
import StudentAttendance from "./components/studentattendance";
import Examination from "./components/exam";
import StudentList from "./components/studentlist";
import StudentProfile from "./components/studentprofile";
import TeacherList from "./components/teacherlist";
import TeacherProfile from "./components/teacherprofile";
import LeaveDashboard from "./components/leave/leavedashboard";
import ApplyLeave from "./components/leave/applyleave";
import IDCardView from "./components/idcard";
import ComplaintList from "./components/complaint/complaintlist";
import AddComplaint from "./components/complaint/addcomplaint";
import EventsList from "./components/events";
import ReportCard from "./components/reportcard";
import MyCertificate from "./components/mycertificate";
import TransportAttendance from "./components/transportattendance";
import AddTransportAttendance from "./components/addtransportattendance";
import FeeReport from "./components/feereport";
import Payslip from "./components/payslip";
import StudentMarkEnter from "./components/studentmarkenter";
import ShareLocation from "./components/sharelocation";
import VehicleTracking from "./components/vehicletracking";

function App() {

  
  return (
    <HashRouter>
      <Routes>
        <Route path="/" exact element={<Navigate to="/login" />} />
        <Route path="/login" exact={true} element={<Athletelogin />} />

        <Route path="/more" element={<MoreInfo />} />

        <Route path="/logout" element={<Logout />} />
        <Route path="/aboutschool" element={<About />} />
        <Route path="/result" element={<Examination />} />
        <Route path="/feessummary" element={<StudentProfile />} />


        <Route path="/studentlist" element={<StudentList/>} />
        <Route path="/student-profile/:id" element={<StudentProfile/>} />
        <Route path="/teacherlist" element={<TeacherList/>} />
        <Route path="/teacher-profile/:id" element={<TeacherProfile/>} />
        <Route path="/leavedashboard" element={<LeaveDashboard/>} />
        <Route path="/applyleave" element={<ApplyLeave/>} />
        <Route path="/idcard" element={<IDCardView/>} />
        <Route path="/complaint" element={<ComplaintList/>} />
        <Route path="/addcomplaint" element={<AddComplaint/>} />
        <Route path="/complaintdetail/:id" element={<AddComplaint/>} />

        <Route path="/events" element={<EventsList />} />
        <Route path="/reportcard" element={<ReportCard />} />
        <Route path="/mycertificate" element={<MyCertificate />} />
        <Route path="/transportattendance" element={<TransportAttendance />} />
        <Route path="/addtransportattendance" element={<AddTransportAttendance />} />
        <Route path="/feereport" element={<FeeReport />} />
        <Route path="/payslip" element={<Payslip />} />


        <Route path="/addhomework" element={<AddHomework />} />
        <Route path="/studentmarkenter" element={<StudentMarkEnter />} />
        <Route path="/sharelocation" element={<ShareLocation />} />
        <Route path="/vehicletracking" element={<VehicleTracking />} />
        <Route path="/dashboard" element={<TrackingDashboard />} />
        <Route path="/timetable" element={<TimeTable />} />
        <Route path="/homework" element={<Homework />} />
        <Route path="/notification" element={<TrackingNotification />} />
        <Route path="/addattendance" element={<AddAttendance />} />
        <Route path="/myattendance" element={<MyAttendance />} />
        <Route path="/studentattendance" element={<StudentAttendance />} />
        <Route path="/profile" element={<MyProfile />} />

        

      </Routes>
    </HashRouter>
  );
}

export default App;
